import dealsHelper from '@/libs/deals';
import perms from '@/libs/permissions';
import { LOANS_ACH_WRITE } from '@/libs/permissions_list';

export default {
  computed: {
    isAchPaymentAllowed() {
      return perms.checkPermissions([LOANS_ACH_WRITE]) && dealsHelper.isActive(this.loan);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/my_deals/actions/ach_payment/resources/AchPaymentManagerMixin.js